import React from "react";
import { Timeline } from "primereact/timeline";
import StepCard from "./StepCard";

const SidebarContent = ({ data, labels, nameLink, endType }) => {
  const filteredData = data?.filter(
    (item) => item !== null && item !== undefined,
  );

  const events = filteredData.length
    ? filteredData.map((item) => {
        return {
          content: (
            <StepCard
              data={item}
              labels={labels}
              nameLink={nameLink}
              endType={endType}
            />
          ),
        };
      })
    : [1, 2, 3].map((item) => {
        return {
          content: (
            <StepCard
              data={null}
              labels={labels}
              nameLink={nameLink}
              endType={endType}
            />
          ),
        };
      });

  return (
    <div className="sidebar-content-container">
      <Timeline value={events} content={(item) => item.content} />
    </div>
  );
};

export default SidebarContent;
